import { isMyOutlookTable, type TableView } from 'owa-mail-list-store';
import {
    lazySubscribeToRowNotifications,
    lazyUnsubscribeToRowNotifications,
} from 'owa-mail-triage-notifications';
import removeTableFromStore from '../removeTableFromStore';

// Subscribe to notifications for new table
export function onAddTable(tableView: TableView): void {
    if (isMyOutlookTable(tableView.tableQuery)) {
        return;
    }

    lazySubscribeToRowNotifications.importAndExecute(tableView);
}

// Unsubscribe from notifications and remove the table from the store
export function onRemoveTable(tableViewId: string): void {
    lazyUnsubscribeToRowNotifications.importAndExecute(tableViewId);
    removeTableFromStore(tableViewId);
}
